<template>
  <div id="dataSourceWrapper">
    <!-- 搜索栏 -->
    <div class="search-box">
      <div>
        <Input v-model="searchValue" prefix="ios-search-outline" placeholder="请输入数据源名称"
          style="width: 208px; margin-right: 10px;" @on-enter="handleSearchClick" />
        <Button class="ys-confirm" @click="handleSearchClick">搜索</Button>
      </div>
      <div>
        <Button v-if="hasPerm('resources_data_source_add') == 2" class="ys-confirm" icon="ios-add"
          @click="handleAddClick">新建</Button>
      </div>
    </div>
    <!-- 表格 -->
    <el-table :columns="Columns" :tableData="tableData" :loading="tableLoading" :tableHeight="tableHeight"
      @on-btn-click="onBtnClick">
    </el-table>
    <!-- 分页 -->
    <div class="paging-box">
      <Page :total="totalCount" :page-size="12" :current="page" @on-change="handlePagingClick" />
    </div>
    <!-- 新建弹框 -->
    <data-source v-if="currentDataValues" :currentDataStatus="currentDataStatus" :titleLayer="titleLayer"
      :transmitSocName="transmitSocName" @on-jurisdiction-click="onJurisdictionClick"></data-source>
    <!-- 二次确认框 -->
    <Alter ref="AlterModal" :configData="AlterConfigData" @change_ok="deleteSocActionDatas()">
    </Alter>
  </div>
</template>
<script>
  import {
    mapActions
  } from 'vuex';
  import elementResizeDetectorMaker from "element-resize-detector"; // 获取元素的高度
  import ElTable from '_g/commonComponent/table/elTable.vue';
  import Columns from './tableConfig.js'
  import AddDataSource from '../components/addDataSource.vue'
  export default {
    components: {
      'el-table': ElTable,
      'data-source': AddDataSource
    },
    data() {
      return {
        tableData: [], // 数据
        Columns: [], // 表头
        totalCount: 0, // 总条数
        tableHeight: 0,
        searchValue: '', // 搜索框的值
        page: 1, // 当前页
        AlterConfigData: {}, //二次弹框配置数据
        delateItem: null,
        currentDataStatus: false,
        currentDataValues: false,
        titleLayer: '新建',
        transmitSocName: '',
        tableLoading: true, // 表格loading
      }
    },
    methods: {
      ...mapActions([
        "listDataSearch", // 列表查询
        'deleteSocActionData', // 删除
      ]),
      // 获取元素的高度
      getElementHeight() {
        let ERD = elementResizeDetectorMaker();
        let _this = this;
        ERD.listenTo(document.getElementById("dataSourceWrapper"), (element) => {
          _this.tableHeight = (element.offsetHeight - 66 - 60 - 20); // 在该基础上多-20跟分页有间距
        });
      },
      // 操作按钮
      onBtnClick(rowItem, options) {
        switch (options.code) {
          case '编辑':
            this.transmitSocName = rowItem.soc_name;
            this.processing(1);
            break;
          case '删除':
            this.delateItem = rowItem;
            this.AlterConfigData = {
              type: "warning",
              title: "警告",
              content: "是否确认删除当前数据源信息？"
            }
            this.$refs.AlterModal.OpenModal();
            break;
          default:
            break;
        }
      },
      // 搜索功能
      handleSearchClick() {
        this.page = 1;
        // 获取列表
        this.listDataSearchs();
      },
      // 分页功能
      handlePagingClick(res) {
        this.page = res;
        // 获取列表
        this.listDataSearchs();
      },
      // 新建功能
      handleAddClick() {
        this.processing(2);
      },
      // 新建跟编辑封装
      processing(code) {
        this.currentDataStatus = true;
        this.currentDataValues = true;
        this.titleLayer = code === 1 ? '编辑' : '新建';
      },
      // 回调
      onJurisdictionClick(res) {
        this.currentDataStatus = false;
        this.currentDataValues = false;
        // 刷新列表
        this.page = 1;
        this.totalCount = 0;
        this.tableData = [];
        this.listDataSearchs();
      },
      // 列表查询
      async listDataSearchs() {
        try {
          this.tableLoading = true;
          const ev = {
            soc_name: this.searchValue || '',
            start_recd: (this.page - 1) * 12,
            limit_recd: 12,
          };
          const data = await this.listDataSearch(ev);
          if (data.request_state) {
            this.totalCount = data.all_recd;
            this.tableData = data.dt_source_list;
            this.tableLoading = false;
          }
        } catch (error) {
          console.log(error);
          this.tableLoading = false;
        }
      },
      // 删除数据
      async deleteSocActionDatas() {
        try {
          const data = await this.deleteSocActionData({
            soc_name: this.delateItem.soc_name
          });
          if (data.request_state) {
            this.$Message.success('删除成功！');
            // 刷新页面
            this.page = 1;
            this.listDataSearchs();
          }
        } catch (error) {
          console.log(error);
        }
      }
    },
    mounted() {
      this.Columns = Columns;
      // 获取元素高度
      this.getElementHeight();
      // 获取列表
      this.listDataSearchs();
    }
  }
</script>
<style lang="less" scoped>
  #dataSourceWrapper {
    position: relative;
    width: 100%;
    height: 100%;
    padding: 0 50px;
    box-sizing: border-box;

    .search-box {
      width: 100%;
      height: 66px;
      padding: 22px 0px 12px 0px;
      box-sizing: border-box;
      display: flex;
      flex-wrap: nowrap;
      justify-content: space-between;
    }

    .paging-box {
      position: fixed;
      bottom: 0px;
      right: 50px;
      z-index: 1;
      height: 60px;
      width: calc(100% - 250);
      text-align: right;
    }
  }
</style>